import Message from './Message';
import { useRef, useEffect } from 'react';

export default function Messages({ messages, onSolicitSaved, inputHeight }) {

    function handleSolicitSaved(e) {
        e.preventDefault();
        const form = e.target;
        const name = form.elements.name.value;
        const email = form.elements.email.value;
        console.log(name, email);
        if (!name || !email) {
            return;
        }
        onSolicitSaved({ name, email });
    }

    function handleSolicitClosed() {
        onSolicitSaved(null);
    }

    useEffect(() => {
        const messagesContainer = document.querySelector('#PageParrotRoot .messages');
        if (messagesContainer) {
            // Create or update the style element for the scrollbar
            let styleEl = document.getElementById('scrollbar-style');
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = 'scrollbar-style';
                document.head.appendChild(styleEl);
            }
            
            // Set the scrollbar margins dynamically
            styleEl.textContent = `
                #PageParrotRoot .messages::-webkit-scrollbar-track {
                    margin: 4px 0 ${inputHeight + 5}px 0 !important;
                }
                #PageParrotRoot .messages::-webkit-scrollbar-thumb {
                    margin: 4px 0 ${inputHeight + 5}px 0 !important;
                }
            `;
        }
        
    }, [inputHeight]);

    return (
        <div className='messages' style={{ paddingBottom: `${inputHeight + 5}px` }}>
            <div className='message_list'>
                <ReverseScrollToBottom>
                    {messages && messages.map(msg => {
                            if (msg.fileURLArray) {
                                return msg.fileURLArray.map((file, index) => {
                                    return <Message 
                                        key={msg.createdAt.seconds + msg.createdAt.nanoseconds + index} 
                                        message={file.fileName} 
                                        msgType={msg.msgType} 
                                        slack_ts={msg.slack_ts} 
                                        handleSolicitSaved={handleSolicitSaved}
                                        handleSolicitClosed={handleSolicitClosed}
                                        fileUrl={file.resultURL} 
                                        fileName={file.fileName}
                                    />
                                })
                            }
                            else {
                                return <Message 
                                    key={msg.createdAt.seconds + msg.createdAt.nanoseconds} 
                                    message={msg.text} 
                                    msgType={msg.msgType} 
                                    slack_ts={msg.slack_ts} 
                                    handleSolicitSaved={handleSolicitSaved}
                                    handleSolicitClosed={handleSolicitClosed}
                                    fileUrl={msg.fileUrl}
                                    discord_ts={msg.discord_ts}
                                    fileName={msg.fileName}
                                />
                            }
                        })
                    }
                </ReverseScrollToBottom>
            </div>
        </div>
    )
}

function ReverseScrollToBottom({ children }) {
    const messagesEndRef = useRef(null);
    
    useEffect(() => {
        setTimeout(() => {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }, [children]);

    return (
        <div>
            {children}
            <div ref={messagesEndRef}/>
        </div>
    );
};